import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIncidents = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M10.846 18.545c.05.595-.448 1.095-1.013.903-1.547-.526-4.083-1.936-4.083-5.521.289-2.078 1.251-3.675 1.795-5.659.216-.79.305-1.167.518-3.457 0-.974.837-1.91 1.887-1.384 1.417.708 1.718 2.74 2.1 5.25.3 1.963.744 2.316 1.204.55.048-.315.125-.633.125-.959 0-1.33 1.507-1.163 1.985-.334 2.758 4.778 3.025 9.869-1.769 11.533-.504.175-.942-.2-.89-.73.123-1.277.232-3.235-.918-3.235-1.023 0-1.049 1.79-.941 3.043"
    />
  </svg>
);
export default SvgIncidents;
